import { render, staticRenderFns } from "./policy-yuri-videos.vue?vue&type=template&id=602588d2&scoped=true&"
import script from "./policy-yuri-videos.vue?vue&type=script&lang=js&"
export * from "./policy-yuri-videos.vue?vue&type=script&lang=js&"
import style0 from "./policy-yuri-videos.vue?vue&type=style&index=0&id=602588d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602588d2",
  null
  
)

export default component.exports